module.exports = __webpack_public_path__ + "static/Clover-3c93b885cd5fefb6e3419b67b3c32ecd.jpg";